'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _keys = require('babel-runtime/core-js/object/keys');

var _keys2 = _interopRequireDefault(_keys);

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _redboxReact2 = require('redbox-react');

var _redboxReact3 = _interopRequireDefault(_redboxReact2);

var _react2 = require('react');

var _react3 = _interopRequireDefault(_react2);

var _reactTransformCatchErrors3 = require('react-transform-catch-errors');

var _reactTransformCatchErrors4 = _interopRequireDefault(_reactTransformCatchErrors3);

var _class, _temp;

var _server = require('react-dom/server');

var _server2 = _interopRequireDefault(_server);

var _serializeJavascript = require('serialize-javascript');

var _serializeJavascript2 = _interopRequireDefault(_serializeJavascript);

var _reactHelmet = require('react-helmet');

var _reactHelmet2 = _interopRequireDefault(_reactHelmet);

var _helpers = require('helpers');

var _utils = require('helpers/utils');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _components = {
    Html: {
        displayName: 'Html'
    }
};

var _reactTransformCatchErrors2 = (0, _reactTransformCatchErrors4.default)({
    filename: '/usr/local/ibonus/src/helpers/Html.js',
    components: _components,
    locals: [],
    imports: [_react3.default, _redboxReact3.default]
});

function _wrapComponent(id) {
    return function (Component) {
        return _reactTransformCatchErrors2(Component, id);
    };
}

var Html = _wrapComponent('Html')((_temp = _class = function (_Component) {
    (0, _inherits3.default)(Html, _Component);

    function Html() {
        (0, _classCallCheck3.default)(this, Html);
        return (0, _possibleConstructorReturn3.default)(this, (Html.__proto__ || (0, _getPrototypeOf2.default)(Html)).apply(this, arguments));
    }

    (0, _createClass3.default)(Html, [{
        key: 'render',
        value: function render() {
            var _props = this.props,
                assets = _props.assets,
                component = _props.component,
                store = _props.store,
                color_id = _props.color_id,
                beforeEndBody = _props.beforeEndBody,
                beforeEndHead = _props.beforeEndHead,
                afterBeginHead = _props.afterBeginHead,
                afterBeginBody = _props.afterBeginBody;

            var content = component ? _server2.default.renderToString(component) : '';
            var head = _reactHelmet2.default.rewind();
            var storeData = store.getState();

            try {
                var storeDataTest = (0, _serializeJavascript2.default)(store.getState());
            } catch (e) {
                storeData = {};
                var storeDataForError = store.getState();
                var item = void 0;
                for (var key in storeDataForError) {
                    try {
                        if (key == 'modal') {
                            continue;
                        }
                        item = (0, _serializeJavascript2.default)(storeDataForError[key]);
                        storeData[key] = storeDataForError[key];
                    } catch (e) {
                        // Пробуем найти причину падения
                        console.error('FAIL serialize JSON, KEY - ' + key);
                    }
                }
            }

            return _react3.default.createElement(
                'html',
                { lang: 'ru' },
                _react3.default.createElement(
                    'head',
                    null,
                    _react3.default.createElement('meta', { charSet: 'utf-8' }),
                    typeof afterBeginHead === 'function' ? _react3.default.createElement('div', {
                        dangerouslySetInnerHTML: { __html: typeof afterBeginHead === 'function' && afterBeginHead() } }) : '',
                    head.base.toComponent(),
                    head.title.toComponent(),
                    head.meta.toComponent(),
                    head.link.toComponent(),
                    head.script.toComponent(),
                    _react3.default.createElement('link', { rel: 'apple-touch-icon', sizes: '180x180', href: '/apple-touch-icon.png' }),
                    _react3.default.createElement('link', { rel: 'icon', type: 'image/png', sizes: '32x32', href: '/favicon-32x32.png' }),
                    _react3.default.createElement('link', { rel: 'icon', type: 'image/png', sizes: '16x16', href: '/favicon-16x16.png' }),
                    _react3.default.createElement('link', { rel: 'icon', type: 'image/ico', href: '/favicon.ico' }),
                    _react3.default.createElement('link', { rel: 'manifest', href: '/manifest.json' }),
                    _react3.default.createElement('meta', { name: 'msapplication-TileColor', content: '#00aba9' }),
                    _react3.default.createElement('meta', { name: 'msapplication-TileImage', content: '/mstile-144x144.png' }),
                    _react3.default.createElement('meta', { name: 'theme-color', content: '#ffffff' }),
                    _react3.default.createElement('meta', { name: 'msapplication-config', content: '/browserconfig.xml' }),
                    _react3.default.createElement('meta', { name: 'viewport',
                        content: 'width=device-width, initial-scale=1, maximum-scale=1.0, user-scalable=no' }),
                    _react3.default.createElement('link', { href: 'https://fonts.googleapis.com/css?family=Open+Sans:300,400,600,700,800', rel: 'stylesheet',
                        type: 'text/css' }),
                    (0, _keys2.default)(assets.styles).map(function (style, key) {
                        return _react3.default.createElement('link', { href: assets.styles[style], key: key, media: 'screen, projection', rel: 'stylesheet',
                            type: 'text/css', charSet: 'UTF-8' });
                    }),
                    (0, _keys2.default)(assets.styles).length === 0 ? _react3.default.createElement('style', { dangerouslySetInnerHTML: { __html: require('../containers/App/default/App.less') } }) : null,
                    _react3.default.createElement('div', { dangerouslySetInnerHTML: { __html: typeof beforeEndHead === 'function' && beforeEndHead() } })
                ),
                _react3.default.createElement(
                    'body',
                    { className: (0, _utils.getClassColorByColorId)(color_id) },
                    typeof afterBeginHead === 'function' ? _react3.default.createElement('div', { dangerouslySetInnerHTML: { __html: typeof afterBeginBody === 'function' && afterBeginBody() } }) : '',
                    _react3.default.createElement('script', { src: 'https://forma.tinkoff.ru/static/onlineScript.js' }),
                    _react3.default.createElement('script', { src: 'https://yastatic.net/es5-shims/0.0.2/es5-shims.min.js' }),
                    _react3.default.createElement('script', { src: 'https://yastatic.net/share2/share.js' }),
                    _react3.default.createElement('div', { id: 'content', className: 'u-full-height', dangerouslySetInnerHTML: { __html: content } }),
                    _react3.default.createElement('script', { src: 'https://code.jquery.com/jquery-3.1.1.min.js' }),
                    _react3.default.createElement('script', { src: '//ajax.googleapis.com/ajax/libs/jqueryui/1.11.2/jquery-ui.min.js' }),
                    _react3.default.createElement('script', { dangerouslySetInnerHTML: { __html: 'window.__data=' + (0, _serializeJavascript2.default)(storeData) + ';' },
                        charSet: 'UTF-8' }),
                    _react3.default.createElement('script', { src: assets.javascript.main, charSet: 'UTF-8' }),
                    this.props.googleCaptcha ? _react3.default.createElement('script', { src: this.props.googleCaptchaUrl }) : '',
                    this.props.turnstileCaptcha ? _react3.default.createElement('script', { src: 'https://challenges.cloudflare.com/turnstile/v0/api.js?render=explicit' }) : '',
                    _react3.default.createElement('div', { dangerouslySetInnerHTML: { __html: typeof beforeEndBody === 'function' && beforeEndBody() } })
                )
            );
        }
    }]);
    return Html;
}(_react2.Component), _class.propTypes = {
    assets: _react2.PropTypes.object,
    component: _react2.PropTypes.node,
    store: _react2.PropTypes.object,
    color_id: _react2.PropTypes.number
}, _temp));

exports.default = Html;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/helpers/Html.js
// module id = 1856
// module chunks = 0